module.exports = __webpack_public_path__ + "static/img/exclusive-membership-envelope.f8e702c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exclusive-membership-envelope.gif
// module id = 843
// module chunks = 117